// extracted by mini-css-extract-plugin
export default {"banner":"ProfileBanner_banner__xWSm7","avatar":"ProfileBanner_avatar__K6+T1","title":"ProfileBanner_title__kbZls","text":"ProfileBanner_text__vaKHO"};